<script>
  import { link } from "svelte-routing";

  // core components
  import PagesDropdown from "components/Dropdowns/PagesDropdown.svelte";
  import { t } from 'svelte-i18n';
  import { setLanguage } from '../../lib/i18n';

  let navbarOpen = false;

  function setNavbarOpen() {
    navbarOpen = !navbarOpen;
  }

  function changeLanguage(lang) {
    setLanguage(lang);
    navbarOpen = false;
  }
</script>

<nav
  class="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"
>
  <div
    class="container px-4 mx-auto flex flex-wrap items-center justify-between"
  >
    <div
      class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
    >
      <a
        use:link
        class="text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
        href="https://seraphsystems.com"
        target="_blank"
      >
        <img src="/assets/images/seraph_white_isologo.png" alt="Seraph Systems" class="h-8" />
      </a>
      <button
        class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
        type="button"
        on:click="{setNavbarOpen}"
      >
        <i class="text-white fas fa-bars"></i>
      </button>
    </div>
    <div
      class="lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none rounded shadow-lg {navbarOpen ? 'block':'hidden'}"
      id="example-navbar-warning"
    >
      <ul class="flex flex-col lg:flex-row list-none mr-auto">
        <li class="flex items-center">
          <a
            class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://seraphsystems.com/nosotros"
            target="_blank"
          >
            <i
              class="lg:text-blueGray-200 text-blueGray-400 far fa-file-alt text-lg leading-lg mr-2"
            />
            Nosotros
          </a>
        </li>
      </ul>
      <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
        <li class="flex items-center">
          <PagesDropdown />
        </li>
        <li class="flex items-center">
          <div class="px-3 py-2 text-xs uppercase font-bold lg:text-white lg:hover:text-blueGray-200 text-blueGray-700">{$t('user.language')}:</div>
          <a href="#erpsys" on:click={(e)=>{e.preventDefault(); changeLanguage('en');}} class="px-2 text-xs uppercase font-bold lg:text-white lg:hover:text-blueGray-200 text-blueGray-700">{$t('user.english')}</a>
          <span class="text-blueGray-400">|</span>
          <a href="#erpsys" on:click={(e)=>{e.preventDefault(); changeLanguage('es');}} class="px-2 text-xs uppercase font-bold lg:text-white lg:hover:text-blueGray-200 text-blueGray-700">{$t('user.spanish')}</a>
        </li>
        <li class="flex items-center">
          <a
            class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://www.linkedin.com/company/seraph-systems-sa"
            target="_blank"
          >
            <i
              class="lg:text-blueGray-200 text-blueGray-400 fab fa-linkedin text-lg leading-lg"
            />
            <span class="lg:hidden inline-block ml-2">LinkedIn</span>
          </a>
        </li>

        <li class="flex items-center">
          <a
            class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://seraphsystems.com/contactenos"
            target="_blank"
          >
            <i
              class="lg:text-blueGray-200 text-blueGray-400 fas fa-envelope text-lg leading-lg"
            />
            <span class="lg:hidden inline-block ml-2">Contáctanos</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
